import { render, staticRenderFns } from "./PrincipalRegistration.vue?vue&type=template&id=260c4e6a&scoped=true&"
import script from "./PrincipalRegistration.vue?vue&type=script&lang=js&"
export * from "./PrincipalRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalRegistration.vue?vue&type=style&index=0&id=260c4e6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c4e6a",
  null
  
)

export default component.exports